var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsisIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 4,
    viewBox: "0 0 14 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 0.875C0.75625 0.875 0.25 1.38125 0.25 2C0.25 2.61875 0.75625 3.125 1.375 3.125C1.99375 3.125 2.5 2.61875 2.5 2C2.5 1.38125 1.99375 0.875 1.375 0.875ZM12.625 0.875C12.0063 0.875 11.5 1.38125 11.5 2C11.5 2.61875 12.0063 3.125 12.625 3.125C13.2437 3.125 13.75 2.61875 13.75 2C13.75 1.38125 13.2437 0.875 12.625 0.875ZM7 0.875C6.38125 0.875 5.875 1.38125 5.875 2C5.875 2.61875 6.38125 3.125 7 3.125C7.61875 3.125 8.125 2.61875 8.125 2C8.125 1.38125 7.61875 0.875 7 0.875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisIcon);
export default __webpack_public_path__ + "static/media/ellipsis-icon.61e5241ee4755916b771622648955e7f.svg";
export { ForwardRef as ReactComponent };